<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 6.44769C10 5.11653 11.4836 4.32255 12.5912 5.06094L32.9199 18.6134C33.9094 19.2731 33.9094 20.7272 32.9199 21.3869L12.5912 34.9394C11.4836 35.6778 10 34.8838 10 33.5526V6.44769Z" fill="white"/>
</svg>
